import { ModuleName, moduleName } from '@edgvr-front/modules/domain';
import { Validate } from '@edgvr-front/util/validate';
import {
  DataId,
  DataStartedAt,
  DataPersonEntityId,
  DataPersonName,
  DataPersonEntityRaw as DataPersonEntityRaw0,
} from '../interface';
import {
  dataId,
  dataPersonEntityId,
  dataPersonName,
  dataStartedAt,
} from '../schema';
import { DataPersonVO, DataVO } from '../vo';

export class DataPersonEntity {
  private static validation = Validate.compile(
    DataPersonEntity.validationSchema(),
    DataVO,
    DataPersonVO
  );

  constructor(readonly value: DataPersonEntityRaw) {
    Validate.assert(DataPersonEntity.validation, value);
  }

  toJSON() {
    return {
      ...this.value,
      data: this.value.data.toJSON(),
      dataPerson: this.value.dataPerson.toJSON(),
    };
  }

  static factory(dataPersonEntityRaw0: DataPersonEntityRaw0) {
    return new DataPersonEntity({
      ...dataPersonEntityRaw0,
      data: DataVO.factory(dataPersonEntityRaw0.data),
      dataPerson: new DataPersonVO(dataPersonEntityRaw0.dataPerson),
    });
  }

  private static validationSchema() {
    return {
      type: 'object',
      required: [
        'id',
        'personName',
        'dataId',
        'data',
        'dataPerson',
        'startedAt',
      ],
      properties: {
        id: dataPersonEntityId,
        personName: dataPersonName,
        dataId,
        data: {
          instanceof: DataVO.name,
        },
        dataPerson: {
          instanceof: DataPersonVO.name,
        },
        startedAt: dataStartedAt,
      },
      additionalProperties: false,
    };
  }
}

interface DataPersonEntityRaw {
  id: DataPersonEntityId;
  personName: DataPersonName;
  dataId: DataId;
  data: DataVO;
  dataPerson: DataPersonVO;
  startedAt: DataStartedAt;
}
